var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-stepper",
    {
      model: {
        value: _vm.step,
        callback: function ($$v) {
          _vm.step = $$v
        },
        expression: "step",
      },
    },
    [
      _c(
        "v-stepper-header",
        { staticClass: "elevation-0" },
        [
          _c("v-stepper-step", { attrs: { id: "step-1", step: "1" } }, [
            _vm._v(" Login Credentials "),
          ]),
          _c("v-divider"),
          _c("v-stepper-step", { attrs: { id: "step-2", step: "2" } }, [
            _vm._v(" Search Execution Events "),
          ]),
        ],
        1
      ),
      _c(
        "v-stepper-items",
        [
          _c(
            "v-stepper-content",
            { attrs: { step: "1" } },
            [
              _c("AuthStep", {
                on: {
                  authenticated: _vm.onAuthenticationComplete,
                  error: function ($event) {
                    _vm.errorCount += 1
                  },
                  "show-help": function ($event) {
                    _vm.errorCount = -1
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-stepper-content",
            { attrs: { step: "2" } },
            [
              _vm.splunkConfig
                ? _c("FileList", {
                    attrs: { "splunk-config": _vm.splunkConfig },
                    on: { signOut: _vm.onSignOut, "got-files": _vm.gotFiles },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          attrs: {
            opacity: 50,
            absolute: "absolute",
            value: _vm.errorCount >= 3 || _vm.errorCount < 0,
          },
        },
        [
          _c(
            "div",
            { staticClass: "text-left" },
            [
              _c(
                "p",
                [
                  _vm.errorCount > 0
                    ? _c(
                        "span",
                        {
                          staticStyle: { color: "red", "font-weight": "bold" },
                        },
                        [
                          _vm._v(
                            " It seems you may be having trouble connecting to Splunk. Are you sure that you have configured it properly? "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("br"),
                  _c("span", [
                    _vm._v(
                      " Accessing a Splunk instance from Heimdall requires the input of the following information: "
                    ),
                    _c("br"),
                    _vm._v(
                      " username: A qualified username recognized by the referenced Splunk instance. "
                    ),
                    _c("br"),
                    _vm._v(
                      " password: A qualified password recognized by the referenced Splunk instance. "
                    ),
                    _c("br"),
                    _vm._v(
                      " hostname: The domain name for the desired Splunk instance. Include port number if available. "
                    ),
                    _c("br"),
                    _vm._v(
                      " index: A valid index name within the referenced Splunk instance. "
                    ),
                    _c("br"),
                    _vm._v(
                      " For installation instructions and further information, see: "
                    ),
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        target: "_blank",
                        href: "https://github.com/mitre/heimdall2#splunk",
                        text: "",
                        color: "info",
                        "px-0": "",
                      },
                    },
                    [
                      _c("v-icon", { attrs: { "pr-2": "" } }, [
                        _vm._v("mdi-github-circle"),
                      ]),
                      _vm._v(" Splunk Interfacing Guide "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "info" },
                  on: {
                    click: function ($event) {
                      _vm.errorCount = 0
                    },
                  },
                },
                [_vm._v(" Ok ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }